import Base from 'lib/base'
import locationService from 'service/location'
import Router from 'service/router'
import browsingCommunityModel from 'shared/model/browsing_community'
import currentUserModel from 'shared/model/current_user'

const CommunityChanger = Base.extend({
    change(localcommunity) {
        if (!currentUserModel.isLoggedIn()) {
            return this.loadSeoPage(localcommunity)
        }

        browsingCommunityModel.reset(localcommunity)
    },

    loadSeoPage(localcommunity) {
        const url = Router.path('seo_localcommunity_get', { localcommunityName: localcommunity.urlName })

        return locationService.loadUrl(url)
    },
})

export default new CommunityChanger()
